import {makeAutoObservable} from "mobx"

const data = [
    {value: "BE", label: "Belgien"},
    {value: "BG", label: "Bulgarien"},
    {value: "DK", label: "Dänemark"},
    {value: "DE", label: "Deutschland"},
    {value: "EE", label: "Estland"},
    {value: "FI", label: "Finnland"},
    {value: "FR", label: "Frankreich"},
    {value: "GR", label: "Griechenland"},
    {value: "IE", label: "Irland"},
    {value: "IT", label: "Italien"},
    {value: "HR", label: "Kroatien"},
    {value: "LV", label: "Lettland"},
    {value: "LT", label: "Litauen"},
    {value: "LU", label: "Luxemburg"},
    {value: "MT", label: "Malta"},
    {value: "NL", label: "Niederlande"},
    {value: "AT", label: "Österreich"},
    {value: "PL", label: "Polen"},
    {value: "PT", label: "Portugal"},
    {value: "RO", label: "Rumänien"},
    {value: "SE", label: "Schweden"},
    {value: "SK", label: "Slowakei"},
    {value: "SI", label: "Slowenien"},
    {value: "ES", label: "Spanien"},
    {value: "CZ", label: "Tschechien"},
    {value: "HU", label: "Ungarn"},
    {value: "CY", label: "Zypern"},
    {value: "IS", label: "Island"},
    {value: "LI", label: "Liechtenstein"},
    {value: "NO", label: "Norwegen"},
    {value: "CH", label: "Schweiz"},
    {value: "AL", label: "Albanien"},
    {value: "ME", label: "Montenegro"},
    {value: "BA", label: "Bosnien und Herzegowina"},
    {value: "MD", label: "Moldau, Republik"},
    {value: "MK", label: "Nordmazedonien"},
    {value: "RS", label: "Serbien"},
    {value: "TR", label: "Türkei"},
    {value: "UA", label: "Ukraine"},
    {value: "AD", label: "Andorra"},
    {value: "BY", label: "Belarus"},
    {value: "MC", label: "Monaco"},
    {value: "RU", label: "Russische Föderation"},
    {value: "SM", label: "San Marino"},
    {value: "VA", label: "Vatikanstadt"},
    {value: "GB", label: "Vereinigtes Königreich"},
].sort((a, b) => a.label.localeCompare(b.label))

class CountryStore {

    get options() {
        return data
    }

    constructor() {
        makeAutoObservable(this)
    }
}

const countryStore = new CountryStore()


export {
    countryStore
}
